export default {"src":"/_next/static/media/close.0bf5bca2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};